import React from 'react';
import GridInovua from './GridInovua.jsx';
import GridTanStack from './GridTanStack.jsx';

const USE_TANSTACK = process.env.REACT_APP_USE_TANSTACK_TABLE === 'true';

function Grid(props) {
  if (USE_TANSTACK) {
    return <GridTanStack {...props} />;
  }

  return <GridInovua {...props} />;
}

export default Grid;
